/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DeveloperInputs */



/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Nav_DeveloperInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_developer = /** @type {((inputs?: Nav_DeveloperInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DeveloperInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Développeur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desarrollador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desenvolvedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sviluppatore")
	return /** @type {LocalizedString} */ ("Developer")
});